<template>
  <VWidget>
    <template slot="title">{{ $t('actions') }}</template>

    <template slot="header-actions">
      <v-tooltip top transition="fade-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon small @click="create" v-on="on">
            <v-icon small v-text="$vuetify.icons.values.add" />
          </v-btn>
        </template>
        <span>{{ $t('new') }}</span>
      </v-tooltip>
      <v-btn icon small @click="dismiss">
        <v-icon small>{{ $vuetify.icons.values.close }}</v-icon>
      </v-btn>
    </template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-data-table flat :headers="headers" :items="items" hide-default-footer class="elevation-0">
        <template v-slot:item.actions="{ item }">
          <option-menu :item="item" :editItem="onEdit" :deleteItem="destroy" />
        </template>
      </v-data-table>
      <router-view></router-view>
    </template>
  </VWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { BaseForm, FormErrors, VWidget, OptionMenu } from '@argon/app/components'

export default {
  name: 'ActionsList',
  extends: BaseForm,
  components: { VWidget, FormErrors, OptionMenu },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    },
    dismiss: { type: Function, required: true }
  },
  computed: {
    ...mapState(NAMESPACE, ['current', 'actionTypes']),
    items() {
      return this.current.meta.actions.map((x) => ({
        ...x,
        actionType: this.actionTypes.find((i) => i.type === x.type)
      }))
    },
    headers() {
      return [
        {
          text: this.$t('displayName'),
          value: 'display'
        },
        {
          text: this.$t('type'),
          value: 'actionType.display'
        },
        {
          value: 'actions',
          width: 20,
          sortable: false
        }
      ]
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['deleteAction']),
    getAction(item) {
      return this.current.meta.actions.find((x) => x.name === item.name)
    },
    create() {
      this.$router.push({
        name: 'flowAction',
        params: {
          ...this.$route.params,
          actionName: 'new'
        }
      })
    },
    destroy(item) {
      this.resetServerErrors()
      let data = this.getAction(item)
      let payload = { flowId: this.flowId, data }
      return this.deleteAction(payload).catch(this.setServerErrors)
    },
    onEdit(item) {
      this.$router.push({
        name: 'flowAction',
        params: {
          ...this.$route.params,
          actionName: item.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-btn--icon {
  margin-right: 0;
  margin-left: 0;
}
</style>

<i18n>
{
  "en": {
    "actions": "@:labels.actions",
    "displayName": "@:labels.displayName",
    "new": "New Action",
    "options": "@:labels.options",
    "state": "@:labels.state",
    "type": "Type"
  },
  "fr": {
    "actions": "@:labels.actions",
    "displayName": "@:labels.displayName",
    "new": "Nouvelle action",
    "options": "@:labels.options",
    "state": "@:labels.state",
    "type": "Type"
  }
}
</i18n>
